import { GridItem } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { missingInformationAtom } from '../../../../recoil/atoms/missingInformationAtom';
import AccidentOtherPersonMissingInformationForm from '../AccidentOtherPersonMissingInformationForm';

const OtherPersonMissingInformation = (): JSX.Element => {
    const missingInformation = useRecoilValue(missingInformationAtom);
    const { accidentOtherPerson } = missingInformation;

    if (!accidentOtherPerson?.length) return <></>;

    return (
        <GridItem span={12}>
            {accidentOtherPerson
                .filter((missingInformation) => !!missingInformation.fixedId)
                .map((missingInformation) => {
                    return (
                        <div key={missingInformation.fixedId}>
                            <AccidentOtherPersonMissingInformationForm
                                accidentOtherPersonMissingInformation={missingInformation}
                            />
                        </div>
                    );
                })}
        </GridItem>
    );
};

export default OtherPersonMissingInformation;
